import { Component, ViewChild, Inject, AfterContentChecked, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material";
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { Subject, Subscription, EMPTY } from 'rxjs';

import { config } from "../../../config/index";

import { SnackbarService } from "../shared/services/snackbar.service";
import { FollowUpCommunicationService } from "./parent-ortho.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { PhoneFollowUpPopup } from '../shared/components/modal/phone-follow-up-popup/phone-follow-up-popup.component';
import { FollowUpEmail } from "../shared/components/modal/follow-up-email/follow-up-email.component";
import { PaginationComponent } from "../shared/components/pagination/pagination.component";
import { FollowUpSms } from '../shared/components/modal/follow-up-sms/follow-up-sms.component';

@Component({
    template: require('./parent-ortho.component.html'),
    styles: [require('./parent-ortho.component.less')],
    providers: [FollowUpCommunicationService, MatDialog, SnackbarService, TooltipService],
    preserveWhitespaces: true
})

export class ParentOrthoFollowUpCommunicationComponent implements OnInit, AfterContentChecked, OnDestroy {

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild('communicationHistoryDialog', { static: false }) communicationHistoryDialog: any;
    @ViewChild('previewMailBody', { static: false }) previewMailBody: any;
    @ViewChild('cancelTrackingDialog', { static: false }) cancelTrackingDialog: any;
    @ViewChild('assignBulkRefPatientDialog', { static: false }) assignBulkRefPatientDialog: any;
    @ViewChild('chatHistoryDialog', { static: false }) chatHistoryDialog: any;


    private followUpRedData: any[] = [];
    private followUpYellowData: any[] = [];
    private followUpGreenData: any[] = [];
    followUpListData: any[];
    followUpListCompleteData: any[] = [];
    filteredItems: any[];
    data: any = {};
    locationList: any[] = [];
    allTCList: any[] = [];
    startCount: number;
    followUpTotalCount: number;
    endCount: number;
    master: number;
    selectedType: any;
    paginationItems: any;
    locatManager: string;
    filterExpn: any = {};
    cooAdmin: string;
    followUpListNames: any[] = [];
    private _title: string;
    private _role = config.role;
    private _userRole: string;
    translatedText: string;
    dialogRefEmail: MatDialogRef<FollowUpEmail>;
    dialogRefPhone: MatDialogRef<PhoneFollowUpPopup>;
    dialogRefSms: MatDialogRef<FollowUpSms>;
    reqItemsPerPage: number;
    reqPageOffset: number = 0;
    searchValue: string = '';
    loading: boolean = true;
    updateDateForId: any;
    patientId: any = null;
    colWidth: any = 11;
    loadingFlag: boolean = false;
    messageType: any;
    message: any;
    TCList: any[] = [];
    tcIdValue: any;
    notificationFlag: boolean = false;
    cancelTrackingId: any;
    sortParam: string;
    sortParams: any = ['primary_responsible_party', 'parent_ortho_relapse_candidate', 'patient_name', 'id', 'location','tc_name', 'child_started_date', 'campaign_start_date', 'trigger', 'days_over_due', 'finish_date', 'communication_count'];
    sortParamsConfig: any = [];
    order: string;
    BulkAssign: any = {};
    BulkAssignRequest: any = [];
    selectAll: boolean = false;
    chatHistoryRooms: any = [];
    currentHistoryChatRoom: any;
    selectedRoom: any;
    selectedHistoryList: any;
    messageList: any = [];
    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    isFirstLocFilter: boolean = true;
    isFirstTCFilter: boolean = true;
    isTouchDevice: boolean;
    dialogNewClasses: string;
    isInnerSidebarOpen: boolean = true;
    changeTcSubmit: boolean = false;
    isShowAll: boolean;
    showText: string = 'SHOW_ALL';
    isToggleShowAll: boolean;
    showAllToggleClicked: boolean = false;
    actionListIsOpenFlag: boolean = false;

    limitInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    searchInputSub$: Subject<string> = new Subject<string>();
    searchSubscription: Subscription;
    apiSubscription: Subscription[] = [];
    tcAndLocationSubscription: Subscription[] = [];
    followupFilterApiSubscription: Subscription;
    makeContactApiSubscription: Subscription;
    chatRoomApiSubscription: Subscription;
    showHistorySubscription: Subscription;

    utilServiceSubscriptions: Subscription[] = [];

    constructor(
        @Inject('utilService') private utilService: any,
        private _followUpCommunicationService: FollowUpCommunicationService,
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        public dialog: MatDialog,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _tooltipService: TooltipService

    ) {
        this.utilServiceSubscriptions.push(this.utilService.callParentRelapseAPI.subscribe(this.updateRelapseList));
        this.utilServiceSubscriptions.push(this.utilService.pageListUpdateFromActionRequiredList.subscribe(this.updatePageLists));
    }

    updatePageLists = (data: any) => {
        // if (data.splice_list.includes('all')) {
        //     this.customerList('', this.followUpListData.length, 0);
        // } else {
        //     data.splice_list.forEach((splice_item: any) => {
        //         if (splice_item.followup_type === 'parent_ortho_followup') {
        //             this.followUpListData = this.followUpListData
        //                 .filter((item: any) => item.id !== splice_item.original_id);
        //         }
        //     });
        // }
        this.customerList(this.searchValue, this.followUpListData.length, 0);
    }

    actionRequiredPendingCountUpdate = () => {
        this.utilService.updateActionRequiredListPendingCount.next({update: true});
    }

    updateRelapseList = (data: any) => {
        if (data.callAPI) {
            this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
        }
    }

    createPatientFile(id: any) {
        let from_parent_relapse = {};
        from_parent_relapse['treatment_plan_id'] = id;
        from_parent_relapse['followup_type'] = 'parent_ortho_followup';
        this._sessionStorageService.saveItem('from_parent_relapse', from_parent_relapse);
        this._sessionStorageService.saveItem('viewPatientId', 'add');
        this._router.navigate(['patient/patient-file-add']);
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset)
    }

    customerList = (search: any, pageItems: any, offset: any, fromToggle?: boolean) => {
        this.loading = true;
        this.followupFilterApiSubscription?.unsubscribe();
        let itemLimit = this.isToggleShowAll ? null : pageItems;
        this.followupFilterApiSubscription = this._followUpCommunicationService.followUpFilterService(this.filterExpn, search, itemLimit, offset, this.patientId, this.sortParam, this.order)
            .subscribe(res => this.followUpListSuccessHandler(res, fromToggle),
                error => {
                    if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
                        this.showAllToggleClicked = false;
                        this.isToggleShowAll = !this.isToggleShowAll;
                    }
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role
            this.tcAndLocationSubscription.forEach((subscription) => {
                subscription?.unsubscribe();
            });
            this.getLocations();
            if (this._userRole !== 'TC') {
                this.tcList();
            }
        });
    }

    /**Sort list data based on days_over_due value **/
    overDueSort = (data: any[]) => {
        data.forEach((patient) => {
            patient.idName = 'phone' + patient.patient.id;
            if (patient.days_over_due > 0) {
                this.followUpRedData.push(patient);
                patient.className = "status-colorR";
            }
            else if (patient.days_over_due == 0) {
                this.followUpYellowData.push(patient);
                patient.className = "status-colorY";
            }
            else if (patient.days_over_due < 0) {
                this.followUpGreenData.push(patient);
                patient.className = "status-colorG";
            }
            patient.backgroundClassName = "backgroundW";
        });
    }

    /**
    * Function for Folow Up List Success CallBack
    * @param  {any} response contains response from success CallBack
    */
    followUpListSuccessHandler = (response: any, fromToggle?: boolean) => {
        if (fromToggle) {
            this.setLimit(this.reqItemsPerPage, '', true);
        }

        if (fromToggle || (!fromToggle && this.showAllToggleClicked)) {
            this.isShowAll = !this.isShowAll;
            this.showText = (this.isShowAll) ? 'SHOW_LESS' : 'SHOW_ALL';
            this.showAllToggleClicked = false;
            if (!this.isShowAll) {
                this.clearBulkAssign();
                this.BulkAssignRequest = [];
            }
        }

        if (!response.data) {
            this.followUpListData = [];
            this.followUpListCompleteData = [];
        } else {
            this.overDueSort(response.data);
            this.followUpListData = response.data;
            this.followUpListCompleteData = response.data;
            this.followUpListData.forEach((listData) => {
                this.processFollowUpListData(listData, fromToggle);
            });
        }
        this.selectAll = false;
        this.followUpTotalCount = response.count;
        if (this.reqPageOffset >= 0) {
            if (this.followUpListData.length !== 0) {
                this.startCount = this.reqPageOffset + 1;
                this.endCount = this.startCount + this.followUpListData.length - 1;
            } else {
                this.startCount = 0;
                this.endCount = 0;
            }
        }
        this.loading = false;
        return;
    }

    processFollowUpListData(listData: any, fromToggle: any) {
        listData.openActionListFlag = false;
        listData.showHistory = false;
        listData.historyDataList = [];
        if (fromToggle && this.isShowAll && this.BulkAssign.treatment_plans.indexOf(listData.id) !== -1) {
            listData.selected = true;
        }
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any, fromToggle?: boolean) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            if (!fromToggle) {
                this.clearBulkAssign();
                this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
            }
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.followUpTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        if (event.isClicked) {
            this.clearBulkAssign();
            this.customerList(this.searchValue, event.itemsPerPage, event.offset);
        }
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    _openModal = (person: any, method: any, section: any) => {
        if (person.days_over_due !== null && person.days_over_due >= 0) {
            person.section = section;
            person.method = method;
            if (method === 'email') {
                this.openEmailPreview(person, method);
            } else if (method === 'text') {
                this.openSmsPreview(person);
            }
        }
    }

    openEmailPreview(person: any, method: any) {
        var self = this;
        this._sessionStorageService.saveItem('emailDetails', person).then(() => {
            this.dialogRefEmail = this.dialog.open(FollowUpEmail);
            this._restrictOutsideScrollService.hideBackgroundScroll();
            this.dialogRefEmail.afterClosed().subscribe((result: any) => {
                this._restrictOutsideScrollService.showBackgroundScroll();
                this.dialogRefEmail = null;
                this.data.method = method;
                this.data.message = result;

                if (self.data.message != 'cancel' && self.data.message != undefined) {
                    this.makeContactApiSubscription?.unsubscribe();
                    this.makeContactApiSubscription = this._followUpCommunicationService.makeContact(self.data, person.id)
                        .subscribe((res: any) => {
                            this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                            this.actionRequiredPendingCountUpdate();
                            this._mdlSnackbarService.showSnackbar('EMAIL_SEND_SUCCESS', 'success');
                        },
                            (error: any) => {
                                this._mdlSnackbarService.showSnackbar('EMAIL_SEND_FAIL', 'error');
                            });
                }
                else
                    return;
            });
        });
    }

    openSmsPreview(data: any) {
        if (data?.opt_in_status === 'rejected') {
            return;
        }
        this._sessionStorageService.saveItem('textDetails', data).then(() => {
            this.dialogRefSms = this.dialog.open(FollowUpSms, {
                panelClass: 'sms-editor-popup-wrap',
            });
            this._restrictOutsideScrollService.hideBackgroundScroll();
            this.dialogRefSms.afterClosed().subscribe(result => {
                this._restrictOutsideScrollService.showBackgroundScroll();
            })
        });
    }

    formatAMPM(dateString: any) {
        let date = new Date(dateString);
        let hours = date.getHours();
        let minutes: any = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    showCommunicationHistory(id: any) {
        this.loading = true;
        this.followUpListData.forEach((listData) => {
            if (listData.id === id) {
                listData.showHistory = !listData.showHistory;
                if (listData.showHistory) {
                    this.showHistorySubscription?.unsubscribe();
                    this.showHistorySubscription = this._followUpCommunicationService.followUpHistory(id)
                        .subscribe((res: any) => {
                            listData.historyDataList = res.data;
                            this.loading = false;
                        },
                            error => {
                                this.loading = false;
                                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            });
                }
            }
            else {
                listData.showHistory = false;
            }
            this.loading = false;
        });
    }

    showHistoryPopup(list: any) {
        this.message = list.message;
        if (list.contact_method === 'text') {
            this.message = this.message.replace(/\n/g, "<br>");
            this.previewMailBody.nativeElement.setAttribute('style', 'width: 30vw');
        } else {
            this.previewMailBody.nativeElement.setAttribute('style', 'width: max-content');
        }
        this.previewMailBody.nativeElement.innerHTML = this.message;
        this.messageType = list.contact_method;
        this.communicationHistoryDialog.show();
    }


    showChatHistoryPopup(list: any) {
        this.messageList = [];
        this.selectedHistoryList = list;
        this.currentHistoryChatRoom = null;
        this.chatHistoryDialog.show();
        this.apiSubscription.push(this._followUpCommunicationService.getChatHistoryUsers(list.patient.id)
            .subscribe((res: any) => {
                this.setChatHistoryRooms(res);
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            }));
    }

    chatHistoryPopupClose() {
        this.chatHistoryDialog.close();
    }

    setChatHistoryRooms(res: any) {
        this.chatHistoryRooms = res.data.rooms;
    }

    getChatRoomDetails(room: any) {
        this.selectedRoom = room;
        this.selectedRoom['maxLimitReached'] = false;
        this.chatRoomApiSubscription?.unsubscribe();
        this.chatRoomApiSubscription = this._followUpCommunicationService.getChatRoomDetails(this.selectedRoom.id, 0, 5)
            .subscribe((res: any) => {
                if (this.selectedRoom.sender) {
                    this.setChatHistoryMessages(res, this.selectedRoom.sender?.user_id);
                }
            }, (error: any) => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    setChatHistoryMessages(res: any, sender_id: any) {
        this.messageList = res.data;
        this.messageList.forEach((message: any) => {
            if (message.member?.user_id === sender_id) {
                message['from'] = 'user';
            } else {
                message['from'] = 'patient';
            }
        });
    }

    fetchMessages() {
        if (!this.selectedRoom['maxLimitReached']) {
            this.chatRoomApiSubscription?.unsubscribe();
            this.chatRoomApiSubscription = this._followUpCommunicationService.getChatRoomDetails(this.selectedRoom.id, this.messageList.length, 5)
                .subscribe((res: any) => {
                    this.getChatRoomDetailsSuccessHandler(res);
                }, (error: any) => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        }
    }

    getChatRoomDetailsSuccessHandler(res: any) {
        if (res.data.length > 0) {
            this.messageList = this.messageList.concat(res.data);
            this.messageList.forEach((message: any) => {
                if(this.selectedRoom.sender) {
                    message['from'] = (message.member?.user_id === this.selectedRoom.sender?.user_id) ? 'user' : 'patient';
                }
            });
        } else {
            this.selectedRoom['maxLimitReached'] = true;
        }
    }

    messageTime(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        let timeString;
        let hours = msgdate.getHours();
        if (hours / 12 < 1) {
            timeString = 'AM';
            if (hours % 12 === 0) {
                hours = 12;
            }
        } else {
            timeString = 'PM';
            hours = hours - 12;
        }
        return ('0' + hours).slice(-2) + ":" + ('0' + msgdate.getMinutes()).slice(-2) + " " + timeString;
    }

    messageDate(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        return msgdate.getDate() + " " + this.months[msgdate.getMonth()] + " " + msgdate.getFullYear();
    }

    showMonthLine(display_list: any, index: any) {
        if (index > 0) {
            let currentChatMonth = new Date(display_list[index].sent_at);
            let previousChatMonth = new Date(display_list[index - 1].sent_at);
            if (currentChatMonth.getDate() !== previousChatMonth.getDate()) {
                return true;
            }
            return false;
        }
        return true;
    }

    historyPopupClose() {
        this.communicationHistoryDialog.close();
    }

    updateContactPopupOpen = (listData: any) => {
        if (listData.days_over_due !== null && listData.days_over_due >= 0) {
            this.dialogRefPhone = this.dialog.open(PhoneFollowUpPopup, {
                disableClose: true, panelClass: 'phone-follow-up-popup',
                data: {
                    listData: listData,
                    type: 'parent-follow-up'
                }
            });

            this.dialogRefPhone.afterClosed().subscribe(result => {
                if (result === 'updated') {
                    this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                    this.actionRequiredPendingCountUpdate();
                }
            });
        }
    }

    searchItem(value: any) {
        this.loading = true;
        this.reqPageOffset = 0;
        this.customerList(value, this.reqItemsPerPage, this.reqPageOffset);

    }

    getLocations() {
        let req_filter = true;
        if (this._userRole === 'TC'){
            this.tcAndLocationSubscription.push(this._followUpCommunicationService.getLocationList(req_filter)
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error)));
        } else {
            this.tcAndLocationSubscription.push(this._followUpCommunicationService.getLocationList()
                .subscribe((res: any) => {
                    this.locationList = res.data;
                },
                    error => console.log(error)));
        }
    }

    tcList() {
        this.tcAndLocationSubscription.push(this._followUpCommunicationService.getTCList()
            .subscribe((res: any) => {
                this.allTCList = res.data;
                this.TCList = res.data;
            },
                error => console.log(error)));
    }

    clearBulkAssign() {
        this.BulkAssign.treatment_plans = [];
        this.BulkAssign.locations = [];
        this.BulkAssign.plan_locations = [];
    }

    initiate() {
        this._title = "Follow-Up Communications";
        this.selectedType = 10;
        this.userRoleFetch();
        this.customerList('', 10, 0);
        var table = document.getElementById('follow-up');
        this.clearBulkAssign();
        this.locatManager = config.location_manager;
        this.cooAdmin = config.coo_admin;
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
    }

    openCancelTrackingConfirmationDialog(id: any) {
        this.cancelTrackingId = id;
        this.cancelTrackingDialog.show();
    }

    cancelTracking() {
        this.loading = true;
        this.apiSubscription.push(this._followUpCommunicationService.cancelTracking(this.cancelTrackingId)
            .subscribe((res: any) => {
                this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                this.actionRequiredPendingCountUpdate();
                this._mdlSnackbarService.showSnackbar('TRACKING_CANCELLED', 'success');
                this.loading = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                }));
        this.cancelTrackingDialog.close();
    }

    isAssignUserSameLocation(user: any, location_id: number) {
        let status;
        if (user.locations) {
            status = user.locations.find((location: any) => location.id === location_id);
        }
        return status ? true : false;
    }

    checkEvenTCForOtherLocations(tc: any, location_id: number) {
        let availableTCs = this.allTCList.filter((tc: any) => !this.isAssignUserSameLocation(tc, location_id));
        let index = availableTCs.indexOf(tc);
        return index%2 ? true : false;
    }

    /**
    * Function for setting Bulk Assign Object
    */
     setBulkAssignRequestObj() {
        this.BulkAssignRequest = [];
        let selectedLocations = new Set(this.BulkAssign.locations);
        selectedLocations.forEach((location_id: any) => {
            let location_name = this.BulkAssign.plan_locations.find((plan_locations: any) => plan_locations.location_id === location_id).location_name;
            let location_plans = this.BulkAssign.plan_locations.reduce((plans: any, plan_locations: any) => {
                if (plan_locations.location_id === location_id) {
                   plans.push(plan_locations.plan_id);
                }
                return plans;
              }, []);
            if (location_plans.length) {
                this.BulkAssignRequest.push({location_id: location_id, treatment_plan_ids: location_plans, location_name: location_name, confirmTransfer: true});
            }
        });
    }

    /**
    * Function for selecting a patient
    */
    selectPatient(plan: any, index: number) {
        event.stopPropagation();
        if (this.followUpListData[index].selected) {
            this.BulkAssign.treatment_plans.push(plan.id);
            this.BulkAssign.plan_locations.push({location_id: plan.location.id, plan_id: plan.id, location_name: plan.location.city.name});
            this.BulkAssign.locations.push(plan.location.id);
            if (this.BulkAssign.treatment_plans.length === this.followUpListData.length) {
                this.selectAll = true;
            }
        }
        else {
            this.selectAll = false;
            let ind = this.BulkAssign.treatment_plans.indexOf(plan.id);
            if (index > -1) {
                this.BulkAssign.treatment_plans.splice(ind, 1);
                this.BulkAssign.plan_locations.splice(ind, 1);
                this.BulkAssign.locations.splice(ind, 1);
            }
        }
        this.setBulkAssignRequestObj();
    }

    /**
    * function for select all patients
    */
    selectAllpatients() {
        event.stopPropagation();
        this.clearBulkAssign();
        var that = this;
        this.followUpListData.forEach(function (plan) {
            plan.selected = that.selectAll;
            that.BulkAssign.treatment_plans.push(plan.id);
            that.BulkAssign.plan_locations.push({location_id: plan.location.id, plan_id: plan.id, location_name: plan.location.city.name});
            that.BulkAssign.locations.push(plan.location.id);
        });
        if (!this.selectAll) {
            this.clearBulkAssign();
        }
        this.setBulkAssignRequestObj();
    }

    /**
    * Open bulk assign model
    */

    bulkAssign() {
        this.changeTcSubmit = false;
        this.assignBulkRefPatientDialog.show();
    }

    /**
    * Close bulk assign model
    */

    assignBulkDialogClose() {
        this.BulkAssignRequest.forEach((plan_location: any) => {
            if (plan_location.tc_id) {
                delete plan_location.tc_id;
            }
            plan_location.confirmTransfer = true;
        });
        this.assignBulkRefPatientDialog.close();
    }

    /**
    * Function for assign bulk
    */

    assignBulkTC() {
        this.changeTcSubmit = true;
        let reqData: any = [];
        let validRequest: boolean = true;
        this.BulkAssignRequest.forEach((plan_location: any) => {
            if (plan_location.confirmTransfer) {
                reqData.push(plan_location);
                if (!plan_location.tc_id) {
                    validRequest = false;
                }
            }
        });
        if (validRequest) {
            this.apiSubscription.push(this._followUpCommunicationService.assignBulkTCUpdate(reqData)
                .subscribe((res: any) => {
                    this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset);
                    this.BulkAssign = {};
                    this.clearBulkAssign();
                    this.BulkAssignRequest = [];
                    this.selectAll = false;
                    this._mdlSnackbarService.showSnackbar('TC_ASSIGN_SUCCESS', 'success');
                    this.assignBulkRefPatientDialog.close();
                }, (error: any) => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
        } else {
            this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
        }
    }

    resetPageOffset() {
        this.reqPageOffset = 0;
    }

    filterChange(parameter: any, value: any) {
        this.loading = true;
        this.resetPageOffset();
        if (this.searchValue === undefined)
            this.searchValue = '';
        if (this.reqItemsPerPage === undefined)
            this.reqItemsPerPage = 10;
        let itemLimit = this.isToggleShowAll ? null : this.reqItemsPerPage;
        if (parameter === 'location') {
            if (this.isFirstLocFilter) {
                this.isFirstLocFilter = false;
            } else {
                this.checkValueChange(value, itemLimit);
            }
        } else {
            if (this.isFirstTCFilter) {
                this.isFirstTCFilter = false;
            } else {
                if (value === undefined) {
                    this.filterExpn.tc = undefined;
                } else {
                    this.filterExpn.tc = value;
                }
                this.followupFilterApiSubscription?.unsubscribe();
                this.followupFilterApiSubscription =
                    this._followUpCommunicationService
                        .followUpFilterService(
                            this.filterExpn,
                            this.searchValue,
                            itemLimit,
                            this.reqPageOffset,
                            this.patientId,
                            this.sortParam,
                            this.order
                        )
                        .subscribe(
                            (res: any) => this.followUpListSuccessHandler(res),
                            (error) => console.log(error)
                        );
            }
        }
    }

    checkValueChange(value: any, itemLimit: any) {
        if (value === undefined) {
            this.filterExpn.location = undefined;
            this.filterExpn.tc = undefined;
            this.tcIdValue = undefined;
            this.TCList = this.allTCList;
            this.followupFilterApiSubscription?.unsubscribe();
            this.followupFilterApiSubscription =
                this._followUpCommunicationService
                    .followUpFilterService(
                        this.filterExpn,
                        this.searchValue,
                        itemLimit,
                        this.reqPageOffset,
                        this.patientId,
                        this.sortParam,
                        this.order
                    )
                    .subscribe(
                        (res) => this.followUpListSuccessHandler(res),
                        (error) => {
                            this.loading = false;
                            this._mdlSnackbarService.showSnackbar(
                                "SOMETHING_WENT_WRONG",
                                "error"
                            );
                        }
                    );
        } else {
            this.locationList.forEach((location) => {
                if (location.id === value) {
                    this.TCList = location.tc_list;
                    if (this.tcIdValue){
                        this.isFirstTCFilter = true;
                    }
                    this.tcIdValue = undefined;
                    this.filterExpn.location = value;
                    this.filterExpn.tc = undefined;
                    this.followupFilterApiSubscription?.unsubscribe();
                    this.followupFilterApiSubscription =
                        this._followUpCommunicationService
                            .followUpFilterService(
                                this.filterExpn,
                                this.searchValue,
                                itemLimit,
                                this.reqPageOffset,
                                this.patientId,
                                this.sortParam,
                                this.order
                            )
                            .subscribe(
                                (res) => this.followUpListSuccessHandler(res),
                                (error) => {
                                    this.loading = false;
                                    this._mdlSnackbarService.showSnackbar(
                                        "SOMETHING_WENT_WRONG",
                                        "error"
                                    );
                                }
                            );
                }
            });
        }
    }

    openSideBar(event: any){
        this.isInnerSidebarOpen = event;
        if(this.isInnerSidebarOpen){
            this.colWidth = 11;
        } else {
            this.colWidth = 12;
        }
    }

    toggleShowAll() {
        this.showAllToggleClicked = true;
        this.isToggleShowAll = !this.isToggleShowAll;
        this.reqItemsPerPage = (this.isToggleShowAll) ? null : this.selectedType;
        this.reqPageOffset = 0;
        this.customerList(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, true);
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe(params => {
            this.patientId = params['id'];
            if (this.notificationFlag) {
                this.initiate();
            }
            this.notificationFlag = true;
        });
        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();

        // add delay for search on typing
        this.searchSubscription = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(() => {
                this.searchItem(this.searchValue);
                return EMPTY;
            })
        ).subscribe();

        this.initiate();
    }

    OpenActionList(index: any) {
        this.actionListIsOpenFlag = true;
        this.followUpListData?.forEach((element :any,  i = 0) => {
            if( i === index) {
                element.openActionListFlag =   !element.openActionListFlag;
            } else {
                element.openActionListFlag = false;
            }   
        });
    }

    onClickOutside(eve: any, index:any) {
        if( !this.actionListIsOpenFlag) {
            if (eve && eve.target.className.indexOf('dot-btn') === -1) {
                this.followUpListData[index].openActionListFlag = false;   
            }
        }
        this.actionListIsOpenFlag = false;
    }


    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
        if (this.isTouchDevice) {
            this.dialogNewClasses = 'new-dialog-container';
        } else {
            this.dialogNewClasses = 'new-dialog-container desktop-view';
        }
    }

    ngOnDestroy() {
        this.communicationHistoryDialog.close();
        this.cancelTrackingDialog.close();
        this.assignBulkRefPatientDialog.close();
        this.chatHistoryDialog.close();
        this.dialogRefEmail?.close();
        this.dialogRefPhone?.close();
        this.dialogRefSms?.close();

        //Unsubscribing all the subscription
        this.inputSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe();
        this.makeContactApiSubscription?.unsubscribe();
        this.followupFilterApiSubscription?.unsubscribe();
        this.chatRoomApiSubscription?.unsubscribe();
        this.showHistorySubscription?.unsubscribe();
        this.tcAndLocationSubscription.forEach((subscription) => {
            subscription?.unsubscribe();
        });
        this.apiSubscription.forEach((subscription) => {
            subscription?.unsubscribe();
        });

        this.utilServiceSubscriptions.forEach(subscription => subscription?.unsubscribe());
    }
}
